export const NAME = (value) => ({ type: "name", payload: value })
export const VALUE = (value) => ({ type: "value", payload: value })
